import env from '../env';

const getUiOrigin = () => window.location.origin;

export const getKeycloakSsoConfig = async () => {
    const uiOrigin = getUiOrigin();
    const params = new URLSearchParams({
        partnerId: env.partnerId,
        uiOrigin,
    });
    const response = await fetch(`${env.baseURL}/api/public/sso-config?${params.toString()}`);

    if (!response.ok) {
        throw new Error(`Unable to load SSO configuration: ${response.status}`);
    }

    const config = await response.json();
    if (!config.issuer || !config.clientId || !config.redirectUri || !config.baseUIUri) {
        throw new Error('Backend returned incomplete SSO configuration');
    }

    return {...config, uiOrigin};
};
